
function downloadPdf(element,height,width){
var divContents = element.innerHTML;  
var printWindow = window.open('', '', `height=${height},width=${width}`);
printWindow.document.write('<head><style>')
printWindow.document.write(`
@import url('https://fonts.googleapis.com/css2?family=Montserrat&display=swap');
body{margin:0}
.detection-report {
  font-family: 'Montserrat', sans-serif !important;
}

.buttons {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
}

.logo {
  margin: auto;
  background-position: center;
  width: 245px;
  background-size: cover;
  flex: 1;
  height: 46px;
}

.sensemore-logo {
  width: 100%;
  max-width: 188px;
  object-fit: contain;
  float: left;
}

.faultreport-description {
  display: flex;
  flex: 1;
  position: relative;
  background-color: #eeeeee;
  flex-direction: column;
  padding-left: 60px;
  padding-right: 60px;
  width: 50%;
  box-sizing: border-box;
  max-width: 555px;
}

.faultreport-suggestions {
  flex: 1;
  position: relative;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  padding-left: 60px;
  padding-right: 60px;
  width: 50%;
  max-width: 555px;
}

.suggestion-item-container {
  background-color: #eeeeee;
  width: 100%;
  min-height: 80px;
  display: flex;
  font-size: 14px;
  margin-top: 10px;
}

.suggestion-item-padding {
  padding-right: 10px;
  align-items: center;
  display: flex;
}

.suggestion-item-padding p {
  margin-inline-start: 0px !important;
}

p {
  margin-left: 0 !important;
  text-align: left;
  word-break: break-word;
}

.suggestion-item-exclamation {
  width: 30px;
  font-size: 40px;
  text-align: center;
  margin: 0 auto;

}
.detection-report{
min-height:711px;  
}
@media print {
  body {-webkit-print-color-adjust: exact;}
}
@page {
    size: ${width}px ${height}px;
    margin: 0mm;
}

`)

printWindow.document.write('</style></head><body>');
printWindow.document.write(divContents);
printWindow.document.write('</body></html>');
printWindow.document.close();
printWindow.print();
printWindow.onafterprint = window.close;	
}
export default {downloadPdf};